import instance from './instance';

export const extendTrial = () => instance.patch(`/organization/extend_trial`);

export const getGraphData = () => instance.get(`/organization/graph_data`);
